import React, { Component, PropTypes } from 'react';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';

class Model extends Component {

  constructor(props) {
    super(props);
    this.state = {
      option: [''],
      isDataLoaded: false
    }
  }

  componentWillMount() {
    if (this.state.option.length > 0) {
      this.setState({ isDataLoaded: true })
    }
  }

  render() {
    return (
      <FormGroup controlId="model">
        <Col componentClass={ControlLabel} sm={5}>
          Model *
        </Col>
        <Col sm={7}>
          {this.state.isDataLoaded ?
            <select
              className="custom-select"
              onChange={this.props.handleChangeModel}
              onBlur={this.props.calculation}
              value={this.props.model}
              id="model"
              required
            >
              <option value="">Please Select</option>
              {this.props.option.map((obj, index) => {
                const counter = index
                return (
                  <option
                    value={obj.model}
                    key={counter}
                  >{obj.model}</option>
                );
              })}
            </select> : <div>Loading</div>}

        </Col>
      </FormGroup>
    )
  }
}

Model.propTypes = {
  handleChangeModel: PropTypes.func,
  option: PropTypes.array,
  calculation: PropTypes.func,
  model: PropTypes.string
};

export default Model;



// WEBPACK FOOTER //
// ./src/app/components/quotationPVComponent/model/Model.js